import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { showError, showLoading, closeLoading, showSuccess, showWarning } from '../../utils/alerts';
import '../../styles/pages/DeclaracionIVA.css';
import { API_BASE_URL } from '../../config';


const meses = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
];

const DeclaracionIva = ({ token, id_company }) => {
    const currentYear = new Date().getFullYear();
    const [year, setYear] = useState(currentYear);
    const [files, setFiles] = useState(Array(12).fill(null));
    const [estado, setEstado] = useState(
        Array.from({ length: 12 }, () => ({ descargado: false, cargado: false, cerrado: false, pdf_cargado_url: null })));
    const [pagos, setPagos] = useState(
        Array.from({ length: 12 }, () => ({ existe: false, link_pago: null, estado: null, codigo_pago: null })));
    useEffect(() => {
        if (!year) return;
        const fetchEstado = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/api/estado-iva`, {
                  params: { id_company, anual: year },
                  headers: { Authorization: `Bearer ${token}` }
              });                    const newEstado = Array.from({ length: 12 }, () => ({ descargado: false, cargado: false, cerrado: false, pdf_cargado_url: null }));
                res.data.forEach(row => {
                    const idx = row.mes - 1;
                    newEstado[idx] = {
                        descargado: row.descargado,
                        cargado: row.cargado,
                        cerrado: row.cerrado,
                        pdf_cargado_url: row.pdf_cargado_url
                    };
                });
                setEstado(newEstado);
                } catch (err) {
                console.error('Error al obtener estado de IVA:', err);
                }
            };
            fetchEstado();
  }, [year, id_company, token]);

  // Cargar estado de pagos para cada mes
  useEffect(() => {
    if (!year) return;
    const fetchPagos = async () => {
      try {
        const newPagos = Array.from({ length: 12 }, () => ({
          existe: false, link_pago: null, estado: null, codigo_pago: null
        }));

        // Cargar estado de pago para cada mes
        for (let mes = 1; mes <= 12; mes++) {
          try {
            const res = await axios.get(
              `${API_BASE_URL}/api/estado-pago-iva/${id_company}/${year}/${mes}`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.data.existe) {
              newPagos[mes - 1] = res.data;
            }
          } catch (err) {
            // Si no existe el pago, simplemente continuar
            console.log(`No hay pago para mes ${mes}`);
          }
        }

        setPagos(newPagos);
      } catch (err) {
        console.error('Error al obtener estado de pagos:', err);
      }
    };
    fetchPagos();
  }, [year, id_company, token]);

  const handleDescargar = async (index) => {
    try {
      // Generar PDF con URL (se guarda en servidor)
      const pdfRes = await axios.post(`${API_BASE_URL}/api/iva-pdf-url`, {
        id_company,
        anual: year,
        mes: index + 1
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const { url, filename } = pdfRes.data;

      // Descargar desde la URL pública
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      // Marcar como descargado SOLO si el PDF se generó exitosamente
      await axios.post(`${API_BASE_URL}/api/iva-descargar`, {
        id_company,
        anual: year,
        mes: index + 1
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Actualizar estado en el frontend
      setEstado(prev =>
        prev.map((e, i) =>
          i === index ? { ...e, descargado: true } : e
        )
      );

      showSuccess('PDF generado y descargado exitosamente');
    } catch (err) {
      console.error('Error al descargar archivo para pagar:', err);

      // Verificar si el error es por falta de cierre contable
      if (err.response?.status === 400 && err.response?.data?.requiereCierreContable) {
        const { error, message } = err.response.data;
        showError(`${error}\n\n${message}`);
      } else {
        showError('Error al generar el PDF. Inténtalo nuevamente.');
      }
    }
  };

  const handleFileChange = (index, file) => {
    console.log('handleFileChange index', index, 'file', file ? file.name : null);
    const filesCopy = [...files];
    filesCopy[index] = file;
    setFiles(filesCopy);
  };

  const handleUpload = async (index) => {
    const file = files[index];
    if (!file) return;
    console.log('handleUpload index', index, 'file', file.name);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id_company', id_company);
    formData.append('mes', index + 1);
    formData.append('anual', year);
    try {
      showLoading('Procesando PDF con Claude', 'Esto puede tardar unos segundos...');

      // Solo llamar a /api/iva-extraer que ahora hace todo:
      // 1. Extrae datos del PDF con Claude
      // 2. Guarda en base de datos
      // 3. Marca como cargado
      const extraerRes = await axios.post(`${API_BASE_URL}/api/iva-extraer`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` }
      });
      console.log('Success /api/iva-extraer', index, file.name);

      closeLoading();

      // Actualizar estado en el frontend con la URL del PDF
      setEstado(prev =>
        prev.map((e, i) =>
          i === index ? { ...e, cargado: true, pdf_cargado_url: extraerRes.data?.pdf_cargado_url || null } : e
        )
      );

      const { status, message } = extraerRes.data || {};

      if (status === 'error') {
        // Validación NO exitosa - mostrar el mensaje del backend
        const errorMessage = message + '\n\n⚠️ NO se generaron asientos contables. Por favor, revisa los valores.';
        showError('Error de Validación', errorMessage);
      } else if (status === 'warn') {
        showWarning('Advertencia', message);
      } else {
        showSuccess('Éxito', 'El archivo fue procesado correctamente');
      }

    } catch (err) {
      console.error('Error al procesar archivo IVA:', err);
      showError('Error', 'Ocurrió un problema al procesar el archivo');
      closeLoading();
    }
  };
  
  const handleCerrar = async (index) => {
    if (!estado[index].cargado) {
      showError('Debe cargar el IVA pagado antes de cerrar el mes');
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/api/iva-cerrar`, {
        id_company,
        anual: year,
        mes: index + 1
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEstado(prev =>
        prev.map((e, i) =>
          i === index ? { ...e, cerrado: true } : e
        )
      );
    } catch (err) {
      console.error('Error al cerrar mes:', err);
      const message = err.response?.data || 'Error al cerrar mes';
      showError(message);
    }
  };

  const handleGenerarLinkPago = async (index) => {
    try {
      showLoading('Generando link de pago...');
      const res = await axios.post(`${API_BASE_URL}/api/generar-link-pago-iva`, {
        id_company,
        anual: year,
        mes: index + 1
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      closeLoading();

      // Actualizar estado de pagos
      setPagos(prev =>
        prev.map((p, i) =>
          i === index ? {
            existe: true,
            link_pago: res.data.link_pago,
            estado: res.data.estado,
            codigo_pago: res.data.codigo_pago,
            monto: res.data.monto
          } : p
        )
      );

      // Abrir link en nueva pestaña
      window.open(res.data.link_pago, '_blank');

    } catch (err) {
      closeLoading();
      console.error('Error al generar link de pago:', err);
      showError(err.response?.data?.error || 'Error al generar link de pago');
    }
  };

  const handleCopiarLink = (index) => {
    const link = pagos[index].link_pago;
    if (link) {
      navigator.clipboard.writeText(link);
      showSuccess('Link copiado al portapapeles');
    }
  };

  const handleConfirmarPago = async (index) => {
    const pago = pagos[index];
    if (!pago.codigo_pago) return;

    try {
      showLoading('Confirmando pago...');
      await axios.post(`${API_BASE_URL}/api/confirmar-pago-iva`, {
        codigo_pago: pago.codigo_pago,
        notas: `Pago confirmado manualmente para ${meses[index]} ${year}`
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      closeLoading();

      // Actualizar estado
      setPagos(prev =>
        prev.map((p, i) =>
          i === index ? { ...p, estado: 'confirmado' } : p
        )
      );

      showSuccess('Pago confirmado exitosamente');
    } catch (err) {
      closeLoading();
      console.error('Error al confirmar pago:', err);
      showError(err.response?.data?.error || 'Error al confirmar pago');
    }
  };

  const handleDescargarTxt = async (index) => {
    if (!estado[index].descargado) {
      showError('Debe descargar el archivo para pagar antes de descargar el TXT');
      return;
    }

    try {
      showLoading('Generando archivo F29 TXT...');

      const response = await axios.get(`${API_BASE_URL}/api/iva-f29-txt`, {
        params: {
          id_company,
          anual: year,
          mes: index + 1
        },
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob' // Importante para descargar archivos binarios
      });

      closeLoading();

      // Crear un blob con el contenido del archivo
      const blob = new Blob([response.data], { type: 'text/plain' });

      // Obtener el nombre del archivo del header Content-Disposition
      const contentDisposition = response.headers['content-disposition'];
      console.log('Content-Disposition header:', contentDisposition);

      let filename = 'f29.txt';
      if (contentDisposition) {
        // Intentar varios métodos para extraer el nombre del archivo
        // Método 1: filename="archivo.txt"
        let match = contentDisposition.match(/filename="([^"]+)"/);
        if (match) {
          filename = match[1];
        } else {
          // Método 2: filename=archivo.txt (sin comillas)
          match = contentDisposition.match(/filename=([^;]+)/);
          if (match) {
            filename = match[1].trim();
          }
        }
      }

      console.log('Nombre archivo extraído:', filename);

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      showSuccess(`Archivo ${filename} descargado exitosamente`);
    } catch (err) {
      closeLoading();
      console.error('Error al descargar archivo TXT:', err);
      const errorMessage = err.response?.data?.error || 'Error al generar archivo F29 TXT';
      showError(errorMessage);
    }
  };
  return (
    <div className="declaracion-iva">
      <h2>Declaración IVA</h2>
      <label htmlFor="yearSelect">Año:</label>
      <select id="yearSelect" value={year} onChange={(e) => setYear(e.target.value)}>
        {[...Array(5)].map((_, i) => (
          <option key={i} value={currentYear - 2 + i}>
            {currentYear - 2 + i}
          </option>
        ))}
      </select>
      <table>
        <thead>
          <tr>
            <th>Mes</th>
            <th>Descargar archivo para pagar</th>
            <th>Link de pago</th>
            <th>Cargar archivo pagado</th>
            <th>Descargar TXT</th>
            <th>Cerrar mes pagado</th>
          </tr>
        </thead>
        <tbody>
          {meses.map((mes, index) => (
            <tr key={mes}>
              <td>{mes}</td>
              <td>
                <button onClick={() => handleDescargar(index)}>Descargar</button>
                {estado[index].descargado && <span className="status-true">Descargado</span>}
              </td>
              <td>
                {!pagos[index].existe ? (
                  <button
                    onClick={() => handleGenerarLinkPago(index)}
                  >
                    Generar Link
                  </button>
                ) : (
                  <div className="link-pago-container">
                    <button onClick={() => window.open(pagos[index].link_pago, '_blank')}>
                      Abrir Link
                    </button>
                    <button onClick={() => handleCopiarLink(index)}>
                      Copiar
                    </button>
                    {pagos[index].estado === 'confirmado' ? (
                      <span className="status-true">Pagado</span>
                    ) : pagos[index].estado === 'comprobante_subido' ? (
                      <>
                        <span className="status-warning">Pendiente validación</span>
                        {pagos[index].comprobante_url && (
                          <a
                            href={pagos[index].comprobante_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-link"
                          >
                            Ver Comprobante
                          </a>
                        )}
                        <button onClick={() => handleConfirmarPago(index)}>
                          Confirmar
                        </button>
                      </>
                    ) : (
                      <button onClick={() => handleConfirmarPago(index)}>
                        Confirmar Pago
                      </button>
                    )}
                  </div>
                )}
              </td>
              <td>
                <input type="file" onChange={(e) => handleFileChange(index, e.target.files[0])} />
                <button onClick={() => handleUpload(index)}>Cargar</button>
                {estado[index].cargado && <span className="status-true">Cargado</span>}
                {estado[index].pdf_cargado_url && (
                  <a
                    href={estado[index].pdf_cargado_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-link"
                    style={{ marginLeft: '10px' }}
                  >
                    Ver PDF
                  </a>
                )}
              </td>
              <td>
                <button
                  onClick={() => handleDescargarTxt(index)}
                  disabled={!estado[index].descargado}
                  title={!estado[index].descargado ? 'Debe descargar el archivo para pagar primero' : 'Descargar archivo F29 para subir al SII'}
                >
                  Descargar TXT
                </button>
              </td>
              <td>
                <button onClick={() => handleCerrar(index)}>
                  Cerrar
                </button>
                {estado[index].cerrado && <span className="status-true">Cerrado</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );   
};

export default DeclaracionIva;
